import React from 'react';
import axios from '../axios';
import ModalAlert from '../redux/components/modal/modal_alert';
import ModalConfirm from '../redux/components/modal/modal_confirm';
import ModalLoader from '../modal/modal_loader';
import moment from 'moment';
import EventGuide from './event_guide';
// import SectionCashbackshops from './section_cashback_shops';
import SectionImage from './section_image';
import SectionPlans from './section_plans';
import SectionPlansForSampling from './section_plans_for_sampling';
import SectionPlansForCompaniesCircles from './section_plans_for_companies_circles';
import SectionDate from './section_date';
import SectionPlace from './section_place';
import SectionNumOfPeople from './section_num_of_people';
import SectionCircle from './section_circle';
import SectionIsMultiplePurchase from './section_is_multiple_purchase';
import SectionIsGenderManaged from './section_is_gender_managed';
import SectionIsAgeLimited from './section_is_age_limited';
// import SectionMutualRecruiting from './section_mutual_recruiting';
import SectionRecruitUnified from './section_recruit_unified';
import SectionDetail from './section_detail';
import SectionSubject from './section_subject';
import SectionAiButtons from './section_ai_buttons';
import ModalContentBaseXl from '../redux/components/modal/modal_content_base_xl';

const Main = ({
  props,
  historyEventId,
  setPage,
  event,
  setEvent,
  eventsPlans,
  setEventsPlans,
  contents,
  setContents,
  bodyText,
  setBodyText,
  titleText,
  setTitleText,
  circle,
  usersCircles,
  setUsersCircles,
  isNewPolicyApplicable,
  onSelectPlace,
  reservationSummary,
  onEditReservation,
  selectedPlace,
  setSelectedPlace,
}) => {
  const [titleError, setTitleError] = React.useState('');
  const [bodyError, setBodyError] = React.useState('');
  const [categoryError, setCategoryError] = React.useState('');
  const [placeError, setPlaceError] = React.useState('');
  const [capacityError, setCapacityError] = React.useState('');
  const [dateAlert, setDateAlert] = React.useState('');
  const [eventDateError, setEventDateError] = React.useState('');
  const [circleError, setCircleError] = React.useState('');
  const [modalAlertError, setModalAlertError] = React.useState(
    'イベント作成に失敗しました。時間をおいてもう一度お試しください。'
  );
  const [hasPayjp, setHasPayjp] = React.useState(props.myUser.has_payjp);
  const [isDateChangeProhibitionDisplay, setIsDateChangeProhibitionDisplay] =
    React.useState(false);
  const [reservationSummaryState, setReservationSummaryState] =
    React.useState(reservationSummary);
  const isEventEndDatetimeTouched = React.useRef(false);
  const isApplicationDueDateTouched = React.useRef(false);
  const isMeetingDatetimeTouched = React.useRef(false);
  const modalLoaderRef = React.useRef(null);
  const modalAlertSuccessRef = React.useRef(null);
  const modalAlertNewCircleSuccessRef = React.useRef(null);
  const modalAlertDraftSuccessRef = React.useRef(null);
  const modalAlertErrorRef = React.useRef(null);
  const modalAlertValidationErrorRef = React.useRef(null);
  const modalConfirmIsRecruitUnifiedRef = React.useRef(null);
  const modalConfirmSameEventsCreationRef = React.useRef(null);
  const [topBanners, setTopBanners] = React.useState([]);
  const [mutualAutoOffAlert, setMutualAutoOffAlert] = React.useState('');
  const [mutualConditionsError, setMutualConditionsError] = React.useState('');
  const [multiplePurchaseError, setMultiplePurchaseError] = React.useState('');

  const scrollToTop = React.useCallback(() => {
    window.scrollTo({
      top: 0,
      behavior: 'auto',
    });
  }, []);

  const handleEventDateInput = React.useCallback(
    (e) => {
      const target_value = e.target.value;
      if (target_value == null || target_value == '') {
        return;
      }
      if (
        !event.is_new &&
        event.event_date &&
        moment(target_value).format('YYYY/MM/DD') !==
        moment(event.event_date).format('YYYY/MM/DD') &&
        event.regular_participants_count > 0
      ) {
        setIsDateChangeProhibitionDisplay(true);
        setEvent((prev) => ({
          ...prev,
          forceRendarCount: prev.forceRendarCount
            ? prev.forceRendarCount + 1
            : 0,
        })); // 強制的に表示re-rendar
        return;
      }
      // 3週間以上先のイベントでないと相互参加は許可できない
      const twenty_one_days = moment()
        .add(21, 'days')
        .format('YYYY/MM/DD HH:mm');
      const formatted_target_value =
        moment(target_value).format('YYYY/MM/DD HH:mm');
      if (formatted_target_value < twenty_one_days) {
        if (event.is_mutual_recruiting) {
          setEvent((prev) => ({ ...prev, is_mutual_recruiting: false }));
        }
      } else {
        setMutualAutoOffAlert('');
      }
      if (formatted_target_value < twenty_one_days) {
        // 入力値が3週間以内の場合
        setDateAlert('3週間以上先の日時にすることをお勧めします');
      } else {
        setDateAlert('');
      }

      // event_end_datetimeの自動補完
      setEvent((prev) => ({ ...prev, event_date: target_value }));
      if (!isEventEndDatetimeTouched.current) {
        // イベント終了時刻が未編集の場合は自動補完
        const event_end_datetime = moment(target_value)
          .add(2, 'hours')
          .format('YYYY/MM/DD HH:mm');
        setEvent((prev) => ({
          ...prev,
          event_end_datetime: event_end_datetime,
        }));
      } else if (event.event_end_datetime < target_value) {
        setEvent((prev) => ({ ...prev, event_end_datetime: target_value }));
      }

      // application_due_dateの自動補完
      if (
        historyEventId &&
        event.event_date_to_application_due_date_diff_minutes != null
      ) {
        // 過去イベントをコピーしている場合
        const application_due_date = moment(target_value)
          .subtract(event.event_date_to_application_due_date_diff_minutes, 'minutes')
          .format('YYYY/MM/DD HH:mm');
        setEvent((prev) => ({
          ...prev,
          application_due_date: application_due_date,
        }));
      } else if (!isApplicationDueDateTouched.current) {
        // 未編集の場合
        const application_due_date = moment(target_value)
          .subtract(30, 'minutes')
          .format('YYYY/MM/DD HH:mm');
        setEvent((prev) => ({
          ...prev,
          application_due_date: application_due_date,
        }));
      }

      // meeting_datetimeの自動補完
      if (!isMeetingDatetimeTouched.current) {
        // 未編集の場合
        const meeting_datetime = moment(target_value)
          .subtract(5, 'minutes')
          .format('YYYY/MM/DD HH:mm');
        setEvent((prev) => ({ ...prev, meeting_datetime: meeting_datetime }));
      }
    },
    [event, historyEventId]
  );

  // ページを離れるときに警告を出す
  const handleBeforeUnloadEvent = React.useCallback((e) => {
    e.preventDefault();
    e.returnValue =
      !props.isNew && event.is_draft
        ? '現在、このイベントは下書きになっています。公開ボタンを押すまで公開されません。本当にこのページを閉じますか？'
        : '';
  }, []);

  React.useEffect(() => {
    scrollToTop();
    window.addEventListener('beforeunload', handleBeforeUnloadEvent);
    return () =>
      window.removeEventListener('beforeunload', handleBeforeUnloadEvent);
  }, []);

  React.useEffect(() => {
    if (reservationSummary) setReservationSummaryState(reservationSummary);
  }, [reservationSummary]);

  const contentsRef = React.useRef(contents);
  React.useEffect(() => {
    contentsRef.current = contents;
  }, [contents]);

  const updateTextContent = React.useCallback(
    (newBodyText) => {
      const textContent = contentsRef.current.find(
        (content) => content.content_type === 1
      );
      if (textContent && textContent.id) {
        axios
          .post(`/api/event_edit/update_content`, {
            id: textContent.id,
            event_id: event.id,
            body: newBodyText,
          })
          .then((response) => {
            setContents((prev) =>
              prev.map((content) =>
                content.id === textContent.id ? response.data : content
              )
            );
          });
      } else {
        axios
          .post('/api/event_edit/create_content', {
            event_id: event.id,
            body: newBodyText,
            content_type: 1,
          })
          .then((response) => {
            setContents((prev) => [...prev, response.data]);
          })
          .catch(() => {
            setModalAlertError('イベントの説明の保存に失敗しました。もう一度お試しください。');
            modalAlertErrorRef.current.openModal();
          });
      }
    },
    [event]
  );

  // const updateTitleContent = React.useCallback(
  //   (newTitle) => {
  //     const titleContent = contentsRef.current.find(
  //       (content) => content.content_type === 2
  //     );

  //     if (titleContent && titleContent.id) {
  //       axios
  //         .post(`/api/event_edit/update_content`, {
  //           id: titleContent.id,
  //           event_id: event.id,
  //           body: newTitle,
  //         })
  //         .then((response) => {
  //           setContents((prev) =>
  //             prev.map((content) =>
  //               content.id === titleContent.id ? response.data : content
  //             )
  //           );
  //         });
  //     } else {
  //       axios
  //         .post('/api/event_edit/create_content', {
  //           event_id: event.id,
  //           body: newTitle,
  //           content_type: 2,
  //         })
  //         .then((response) => {
  //           setContents((prev) => [...prev, response.data]);
  //         });
  //     }
  //   },
  //   [event]
  // );

  React.useEffect(() => {
    axios
      .get('/api/places', {
        params: {
          is_top_banner_display: 1,
          place_category_id: 11,
          ...(circle.pref_id ? { pref_id: circle.pref_id } : {}),
        },
      })
      .then((res) => setTopBanners(res.data))
      .catch(() => {});
  }, [circle.pref_id]);

  const performPublic = (isRecruitUnified = null) => {
    window.removeEventListener('beforeunload', handleBeforeUnloadEvent);
    modalLoaderRef.current.openModal();

    // 新規作成サークルだったら更新処理
    if (props.isNewCircle) {
      let circle = props.circle;
      circle.is_new_circle = false;
      circle.is_draft = false;
      const body = JSON.stringify(circle);
      axios.post('/api/circles/update', body);
    }

    // イベント説明更新
    // updateTitleContent(titleText);
    updateTextContent(bodyText);
    const urlParams = new URLSearchParams(window.location.search);
    const normalizedEvent = {
      ...event,
      mutual_recruiting_description: event.is_mutual_recruiting
        ? event.mutual_recruiting_description || ''
        : null,
    };
    const eventData =
      isRecruitUnified != null
        ? {
            ...normalizedEvent,
            title: titleText,
            contents: bodyText,
            is_recruit_unified: isRecruitUnified,
            is_draft: false,
            delete_status: 0,
          }
        : {
            ...normalizedEvent,
            title: titleText,
            contents: bodyText,
            is_draft: false,
            delete_status: 0,
          };
    const parentCircleId = urlParams.get('parent_circle_id');

    const eventBody = JSON.stringify({
      event: eventData,
      parent_circle_id: parentCircleId,
      events_plans: eventsPlans,
      talkroom_id: props.talkroomId,
    });
    axios
      .post('/api/event_edit_submit/public', eventBody)
      .then((response) => {
        console.log(props.canCreateSameEvents);
        if (props.isNewCircle) {
          modalAlertNewCircleSuccessRef.current.openModal();
        } else if (
          props.canCreateSameEvents &&
          !props.circle.company_id &&
          !reservationSummaryState &&
          props.isNew
        ) {
          modalConfirmSameEventsCreationRef.current.openModal();
        } else {
          modalAlertSuccessRef.current.openModal();
        }
      })
      .catch((error) => {
        if (error.response && error.response.data) {
          setModalAlertError((prev) => error.response.data.error || prev);
        }
        modalAlertErrorRef.current.openModal();
      })
      .finally(() => {
        modalLoaderRef.current.closeModal();
      });
  };

  const submitPublic = (e) => {
    e.preventDefault();

    const hasErrors = validate();
    if (hasErrors) {
      scrollToTop();
      setTimeout(() => {
        modalAlertValidationErrorRef.current.openModal();
      }, 200);
      return;
    }

    if (!event.is_recruit_unified) {
      modalConfirmIsRecruitUnifiedRef.current.openModal();
      return;
    }

    performPublic();
  };

  const submitDraft = (e) => {
    e.preventDefault();

    window.removeEventListener('beforeunload', handleBeforeUnloadEvent);
    modalLoaderRef.current.openModal();

    // 新規作成サークルだったら更新処理
    if (props.isNewCircle) {
      let circle = props.circle;
      circle.is_new_circle = false;
      circle.is_draft = false;
      const body = JSON.stringify(circle);
      axios.post('/api/circles/update', body);
    }

    // イベント説明更新
    // updateTitleContent(titleText);
    updateTextContent(bodyText);
    const urlParams = new URLSearchParams(window.location.search);
    const parentCircleId = urlParams.get('parent_circle_id');

    const eventBody = JSON.stringify({
      event: {
        ...{
          ...event,
          mutual_recruiting_description: event.is_mutual_recruiting
            ? event.mutual_recruiting_description || ''
            : null,
        },
        title: titleText,
        contents: bodyText,
        is_draft: true,
        delete_status: 0,
      },
      events_plans: eventsPlans,
      talkroom_id: props.talkroomId,
      parent_circle_id: parentCircleId,
    });

    axios
      .post('/api/event_edit_submit/draft', eventBody)
      .then((response) => {
        modalAlertDraftSuccessRef.current.openModal();
      })
      .catch((error) => {
        if (error.response.data) {
          setModalAlertError((prev) => error.response.data.error || prev);
        }
        modalAlertErrorRef.current.openModal();
      })
      .finally(() => {
        modalLoaderRef.current.closeModal();
      });
  };

  const validate = () => {
    let hasErrors = false;
    if (!titleText || titleText.length < 15 || titleText.length >= 61) {
      setTitleError('タイトルは15文字以上60文字以内で入力してください。');
      hasErrors = true;
    } else {
      setTitleError('');
    }
    if (!bodyText) {
      setBodyError('イベントの説明を入力してください。');
      hasErrors = true;
    } else {
      setBodyError('');
    }
    if (!event.is_online && !event.place) {
      setPlaceError('集合場所を入力してください。');
      hasErrors = true;
    } else {
      setPlaceError('');
    }
    if (!event.event_date || !event.event_end_datetime) {
      setEventDateError('イベント日時を入力してください。');
      hasErrors = true;
    } else {
      setEventDateError('');
    }
    if (
      event.application_due_date &&
      event.event_date &&
      moment(event.application_due_date).isAfter(moment(event.event_date))
    ) {
      setEventDateError(
        '募集締め切りはイベント開始時刻より前に設定してください。'
      );
      hasErrors = true;
    }
    if (
      event.min_num_of_people &&
      event.capacity &&
      event.min_num_of_people > event.capacity
    ) {
      setCapacityError(
        '最大人数は、最小催行人数を上回るよう設定してください。'
      );
      hasErrors = true;
    } else {
      setCapacityError('');
    }
    if (!event.circle_id) {
      setCircleError('サークルを選択または作成してください。');
      hasErrors = true;
    } else {
      setCircleError('');
    }
    if (reservationSummaryState) {
      const StartWithinEvent =
        moment(event.event_date) <= moment(reservationSummaryState.start_at);
      const EndWithinEvent =
        moment(event.event_end_datetime) >=
        moment(reservationSummaryState.end_at);
      if (!(StartWithinEvent && EndWithinEvent)) {
        setEventDateError('イベントの日時と会場予約の日時を合わせてください。');
        hasErrors = true;
      }
    }
    if (event.is_mutual_recruiting) {
      const ok = !!(
        event.mutual_recruiting_description &&
        event.mutual_recruiting_description.trim().length > 0
      );
      if (!ok) {
        setMutualConditionsError('相互参加が可能な条件を入力してください。');
        hasErrors = true;
      }
    } else {
      setMutualConditionsError('');
    }
    if (props.isNew && event.is_multiple_purchase_allowed && (event.is_gender_managed || event.is_age_limited)) {
      setMultiplePurchaseError(
        '男女比調整または年齢制限が設定されている場合は、友達分のチケット購入は設定できません。'
      );
      hasErrors = true;
    } else {
      setMultiplePurchaseError('');
    }
    return hasErrors;
  };

  // validationエラーの解消
  React.useEffect(() => {
    if (titleText && titleText.length >= 15 && titleText.length <= 100) {
      setTitleError('');
    }
    if (event.place) {
      setPlaceError('');
    }
    if (bodyText) {
      setBodyError('');
    }
    if (
      event.min_num_of_people &&
      event.capacity &&
      event.min_num_of_people <= event.capacity
    ) {
      setCapacityError('');
    }
    if (!!event.event_date && !!event.event_end_datetime) {
      const applicationDueAfterStart =
        event.application_due_date &&
        moment(event.application_due_date).isAfter(moment(event.event_date));
      if (!applicationDueAfterStart) {
        setEventDateError('');
      }
    }
    if (event.circle_id) {
      setCircleError('');
    }
  }, [event, titleText, bodyText]);

  // 募集締め切りがイベント開始時刻より後のときエラーを表示
  React.useEffect(() => {
    if (
      event.application_due_date &&
      event.event_date &&
      moment(event.application_due_date).isAfter(moment(event.event_date))
    ) {
      setEventDateError(
        '募集締め切りはイベント開始時刻より前に設定してください。'
      );
    }
  }, [event.application_due_date, event.event_date]);

  // React.useEffect(() => {
  //   if (!props.isNew && !event.is_draft) {
  //     const eventBody = JSON.stringify({
  //       event: { ...event, is_draft: true, delete_status: 0 },
  //       events_plans: eventsPlans,
  //       talkroom_id: props.talkroomId,
  //     });
  //     axios
  //       .post('/api/event_edit_submit/draft', eventBody)
  //       .then((response) => {
  //         modalAlertDraftCautionRef.current.openModal();
  //       })
  //       .catch((error) => {
  //         if (error.response.data) {
  //           setModalAlertError((prev) => error.response.data.error || prev);
  //         }
  //         modalAlertErrorRef.current.openModal();
  //       });
  //   }
  // }, []);

  const toTipForSuccess = React.useCallback(() => {
    modalAlertSuccessRef.current.closeModal();
    modalAlertNewCircleSuccessRef.current.closeModal();
    modalConfirmSameEventsCreationRef.current.closeModal();
    modalAlertDraftSuccessRef.current.closeModal();
    modalAlertErrorRef.current.closeModal();
    window.location.href = `/event/${event.id}/tips_for_success`;
  }, []);

  const toEventPage = React.useCallback(() => {
    modalAlertSuccessRef.current.closeModal();
    modalAlertNewCircleSuccessRef.current.closeModal();
    modalConfirmSameEventsCreationRef.current.closeModal();
    modalAlertDraftSuccessRef.current.closeModal();
    modalAlertErrorRef.current.closeModal();
    if (props.circle.company_id) {
      window.location.href =
        '/community/' +
        props.circle.company.id_to_param +
        '/circle/' +
        props.circle.id +
        '/events/' +
        event.id;
    } else {
      window.location.href =
        '/circle/' + props.circle.id + '/events/' + event.id;
    }
  }, []);

  const toSameEventsCreationPage = () => {
    modalAlertSuccessRef.current.closeModal();
    modalAlertNewCircleSuccessRef.current.closeModal();
    modalConfirmSameEventsCreationRef.current.closeModal();
    modalAlertDraftSuccessRef.current.closeModal();
    modalAlertErrorRef.current.closeModal();
    window.location.href = '/event/edit/' + event.id + '/same_events_creation';
  };

  const HistoryEventBtn = React.useCallback(
    () => (
      <div className="w-100 bg-white">
        <div className="container col-md-8 col-lg-6 p-0">
          <div className="d-flex justify-content-end">
            <button
              className="bg-white border-0 mr-2 mt-3 text-fz-12px text-gray text-fw-normal"
              onClick={() => {
                setPage(1);
              }}
            >
              <span style={{ textDecoration: 'underline' }}>
                過去のイベントのコピーでつくる
              </span>
            </button>
          </div>
        </div>
      </div>
    ),
    []
  );

  const onFocusScrollForAndroid = (event) => {
    if (props.userAgent === 'android' && window) {
      const rect = event.target.getBoundingClientRect();
      window.scrollTo({
        top: rect.top + window.scrollY - 30,
        behavior: 'smooth',
      });
    }
  };
  const hasSpaceReservation = !!reservationSummaryState;
  const [modalPageUrl, setModalPageUrl] = React.useState(null);
  const articleModalRef = React.useRef(null);

  return (
    <div>
      <main
        className="bg-gray h-100 min-vh-100"
        style={{ paddingBottom: '144px' }}
      >
        <SectionAiButtons
          titleText={titleText}
          bodyText={bodyText}
          setTitleText={setTitleText}
          setBodyText={setBodyText}
          event={event}
          setEvent={setEvent}
          // updateTitleContent={updateTitleContent}
          updateTextContent={updateTextContent}
        />
        <ModalContentBaseXl
          ref={articleModalRef}
          previewContent={<></>}
          modalContent={
            modalPageUrl ? (
              <iframe
                title="外部ページ"
                src={modalPageUrl}
                style={{ width: '100%', height: '80vh', border: 'none' }}
              />
            ) : (
              <></>
            )
          }
        />
        {/* <SectionCashbackshops /> */}
        {event.circle_id &&
          props.isShowHistoryButton &&
          props.isNew &&
          event.is_new && <HistoryEventBtn />}
        <SectionSubject
          event={event}
          setEvent={setEvent}
          bodyText={bodyText}
          titleText={titleText}
          setBodyText={setBodyText}
          setTitleText={setTitleText}
          categoryError={categoryError}
          setCategoryError={setCategoryError}
          servicesCategories={props.servicesCategories}
          bodyError={bodyError}
          titleError={titleError}
          setTitleError={setTitleError}
          // updateTitleContent={updateTitleContent}
          updateTextContent={updateTextContent}
          onFocusScrollForAndroid={onFocusScrollForAndroid}
          userAgent={props.userAgent}
        />
        <SectionImage
          eventId={event.id}
          mainImageUrl={event.main_image_url_medium_strict || ''}
          setMainImageUrl={(url) =>
            setEvent((prev) => ({ ...prev, main_image_url_medium_strict: url }))
          }
          subImages={
            contents
              .filter(
                (content) =>
                  content.content_type === 3 && content.photo_url_medium
              )
              .sort((a, b) => a.sort_order - b.sort_order)
              .slice(0, 4) || []
          }
          setContents={setContents}
        />
        {circle.sampling_company_id != null && (
          <SectionPlansForSampling
            eventId={event.id}
            reservationSystemFee={props.reservationSystemFee}
            eventsPlans={eventsPlans}
            setEventsPlans={setEventsPlans}
            isNew={props.isNew}
            isCompanyOwnedCircle={props.isCompanyOwnedCircle}
            circlesPlans={props.circlesPlans}
            hasPayjp={hasPayjp}
          />
        )}
        {circle.company_id != null && (
          <SectionPlansForCompaniesCircles
            eventId={event.id}
            reservationSystemFee={props.reservationSystemFee}
            eventsPlans={eventsPlans}
            setEventsPlans={setEventsPlans}
            isNew={props.isNew}
            isCompanyOwnedCircle={props.isCompanyOwnedCircle}
            circlesPlans={props.circlesPlans}
            hasPayjp={hasPayjp}
          />
        )}
        {circle.company_id == null && circle.sampling_company_id == null && (
          <SectionPlans
            eventId={event.id}
            reservationSystemFee={props.reservationSystemFee}
            eventsPlans={eventsPlans}
            setEventsPlans={setEventsPlans}
            isNew={props.isNew}
            isCompanyOwnedCircle={props.isCompanyOwnedCircle}
            circlesPlans={props.circlesPlans}
            hasPayjp={hasPayjp}
            tunagateFeeRate={props.tunagateFeeRate}
          />
        )}
        {!event.semi_official_status && (
          <SectionDate
            event={event}
            setEvent={setEvent}
            dateAlert={dateAlert}
            eventDateError={eventDateError}
            isDateChangeProhibitionDisplay={isDateChangeProhibitionDisplay}
            isEventEndDatetimeTouched={isEventEndDatetimeTouched}
            handleEventDateInput={handleEventDateInput}
          />
        )}
        {!event.is_online && (
          <SectionPlace
            event={event}
            circle={circle}
            setEvent={setEvent}
            setEventDateError={setEventDateError}
            placeError={placeError}
            onSelectPlace={onSelectPlace}
            selectedPlace={selectedPlace}
            clearSelectedPlace={() => {
              setSelectedPlace(null);
              setEvent((prev) => ({ ...prev, place: '', place_detail: '' }));
            }}
            reservationSummary={reservationSummaryState}
            onEditReservation={onEditReservation}
            onCancelReservation={() => setReservationSummaryState(null)}
          />
        )}
        <SectionNumOfPeople
          event={event}
          setEvent={setEvent}
          capacityError={capacityError}
          setPlaceError={setPlaceError}
        />
        {event.is_new && (
          <SectionCircle
            event={event}
            setEvent={setEvent}
            usersCircles={usersCircles}
            setUsersCircles={setUsersCircles}
            circleError={circleError}
          />
        )}
        <SectionRecruitUnified event={event} setEvent={setEvent} />
        {/* ##ここに友達分のチケット購入を追加## */}
        <SectionIsMultiplePurchase
          circle={circle}
          event={event}
          setEvent={setEvent}
          isNew={props.isNew}
          multiplePurchaseError={multiplePurchaseError}
        />

        <SectionIsGenderManaged
          circle={circle}
          event={event}
          setEvent={setEvent}
          isNew={props.isNew}
        />
        <SectionIsAgeLimited
          circle={circle}
          event={event}
          setEvent={setEvent}
          isNew={props.isNew}
        />
        {/* 2026/01/29 廃止 */}
        {/* <SectionMutualRecruiting
          event={event}
          setEvent={setEvent}
          mutualConditionsError={mutualConditionsError}
          isVip={props.isVip}
          creatorTrialRemaining={props.creatorTrialRemaining}
        /> */}
        <SectionDetail
          props={props}
          event={event}
          setEvent={setEvent}
          contents={contents}
          setContents={setContents}
          dateAlert={dateAlert}
          eventDateError={eventDateError}
          isDateChangeProhibitionDisplay={isDateChangeProhibitionDisplay}
          isEventEndDatetimeTouched={isEventEndDatetimeTouched}
          isApplicationDueDateTouched={isApplicationDueDateTouched}
          isMeetingDatetimeTouched={isMeetingDatetimeTouched}
          handleEventDateInput={handleEventDateInput}
          isNewPolicyApplicable={isNewPolicyApplicable}
        />

        <EventGuide />
        <div className="container col-md-8 col-lg-6 mt-5">
          <div
            className="w-100"
            style={{ paddingRight: '10px', paddingLeft: '10px' }}
          >
            <button
              type="button"
              className="mx-1 a-button a-button__top a-button--orange w-100 mb-3"
              value="semi_official"
              onClick={submitPublic}
            >
              イベントを公開する
            </button>
          </div>
          {!props.event?.is_participants_exists_without_creators && (
            <div
              className="w-100"
              style={{ paddingRight: '10px', paddingLeft: '10px' }}
            >
              <button
                type="button"
                className={`mx-1 a-button a-button__top a-button__top--outline w-100 ${
                  props.isApp == false ? 'mb-2' : ''
                }`}
                value="draft"
                onClick={submitDraft}
              >
                下書き
              </button>
            </div>
          )}
        </div>
      </main>

      <ModalConfirm
        ref={modalConfirmSameEventsCreationRef}
        title="イベント作成完了"
        content="イベントを作成しました。
このイベントを来月、再来月も開催しませんか？"
        approveButtonName="続けて別日に開催する"
        rejectButtonName="開催しない"
        approveFunc={() => {
          toSameEventsCreationPage();
        }}
        rejectFunc={() => {
          toEventPage();
        }}
      />
      <ModalAlert
        ref={modalAlertNewCircleSuccessRef}
        id="modalAlertNewCircleSuccess"
        title="サークルと初めてのイベントが
          できました！"
        content="サークルとイベントの情報は後から編集できます。"
        approveFunc={() => {
          if (event.is_new && !event.semi_official_status) {
            toEventPage();
          } else {
            toEventPage();
          }
        }}
      />
      <ModalAlert
        ref={modalAlertSuccessRef}
        id="modalAlertSuccess"
        title="イベント作成完了"
        content={
          hasSpaceReservation
            ? `イベントを作成しました。会場の予約も承りました。`
            : 'イベントを作成しました。'
        }
        approveFunc={() => {
          if (event.is_new && !event.semi_official_status) {
            toEventPage();
          } else {
            toEventPage();
          }
        }}
      />
      <ModalAlert
        ref={modalAlertDraftSuccessRef}
        id="modalAlertDraftSuccess"
        title="下書きイベント作成完了"
        content="下書きイベントを作成しました。"
        approveFunc={() => toEventPage()}
      />
      <ModalAlert
        ref={modalAlertErrorRef}
        id="modalAlertError"
        title="イベント作成失敗"
        content={modalAlertError}
        approveFunc={() =>
          setTimeout(
            () =>
              setModalAlertError(
                'イベント作成に失敗しました。時間をおいてもう一度お試しください。'
              ),
            1000
          )
        }
      />
      <ModalAlert
        ref={modalAlertValidationErrorRef}
        id="modalAlertValidationError"
        title="イベント作成失敗"
        content="イベントが作成できません。必須項目を入力してください。"
      />
      <ModalLoader ref={modalLoaderRef} />
      <ModalConfirm
        ref={modalConfirmIsRecruitUnifiedRef}
        title="つなげーとに集客を一本化しませんか？"
        content="一本化とは、つなげーとだけで集客する、または、つなげーと外の集客においてすべてつなげーとへのリンクを貼り、このイベントページだけで参加者を募ることです。一本化することで優先的に表示されます。"
        approveButtonName="一本化する"
        rejectButtonName="しない"
        approveFunc={() => {
          const isRecruitUnified = true;
          setEvent((prev) => ({
            ...prev,
            is_recruit_unified: isRecruitUnified,
          }));
          modalConfirmIsRecruitUnifiedRef.current.closeModal();
          performPublic(isRecruitUnified);
        }}
        rejectFunc={() => {
          const isRecruitUnified = false;
          setEvent((prev) => ({
            ...prev,
            is_recruit_unified: isRecruitUnified,
          }));
          modalConfirmIsRecruitUnifiedRef.current.closeModal();
          performPublic(isRecruitUnified);
        }}
      />
    </div>
  );
};

export default Main;
